/* ──────────────────────────────────────────────────────────────
 *  ComputeGuardDialog — Blocks compute when inputs are invalid
 *
 *  Shown when the user clicks compute but required inputs are
 *  missing or validation rules fail. Displays a bulleted list
 *  of issues the user must resolve before proceeding.
 *
 *  Ported from BushingApp.compute_guard_dialog (optibush.py).
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Button from '@mui/material/Button';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const ComputeGuardDialog: React.FC = () => {
  const open = useUIStore((s) => s.computeGuardDialogOpen);
  const messages = useUIStore((s) => s.computeGuardPayload);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('computeGuardDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Action Required"
      titleColor="#5e503f"
      icon={<ReportProblemOutlinedIcon sx={{ fontSize: 28, color: 'warning.main' }} />}
      maxWidth={650}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8, fontSize: '14px', color: '#333' }}>
        {messages.map((msg, i) => (
          <li key={i}>{msg}</li>
        ))}
      </ul>
    </DialogShell>
  );
};

export default ComputeGuardDialog;
